import React from 'react';

import ImgIconComp from '../imgcomp';

import { WoboFileUploadService } from '../../../src/services/fileupload.service'

// List Take Attachment
class TakeAttachment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'take',
      showMenuClose: false,
    };
    this.deleteTopicAttach = this.deleteTopicAttach.bind(this);
    this.handleFileDownload = this.handleFileDownload.bind(this);
    this.showCloseMenu = this.showCloseMenu.bind(this);
    this.hideCloseMenu = this.hideCloseMenu.bind(this);
    this.renderFileName = this.renderFileName.bind(this);
  }

  deleteTopicAttach(topicId, takeId, fileId, type, fileSignature) {
    const { isFUSEnabled  } = this.props;
    if (isFUSEnabled && fileSignature) {
      WoboFileUploadService.delete(fileSignature)
    }
    $.get(`${wbConfig.baseUrl}/meeting/deleteAttachment`, { id: fileId,meeting_id:this.props.meeting.id, json: true }, (resp) => {
      if (resp.status === 'ok') {
        create_topic('meet', {
          action: 'delete_topic_attc',
          type: 'take',
          data: { id: fileId },
          topicId,
          takeid: takeId,
        });
      }
    });
    this.props.deleteNoteAttach(topicId, takeId, fileId);
  }

  handleFileDownload(e, item) {
    e.preventDefault();
    const { isNoAttachmentDownload } = this.props;
    if (!isNoAttachmentDownload) return;
    if (item.fusType == 1 && item.fusStatus == 1) {
      const link = document.createElement('a');
      let fileSignature = item.fileSignature ? item.fileSignature : item.file_signature
      const url = `${wbConfig.baseUrl}`+ '/vnext/fus/api/v1/download/' + fileSignature
      WoboFileUploadService.download(url).then(async (res)=>{
          const blob = await res.blob();
          const blobUrl = URL.createObjectURL(new Blob([blob]));
          link.href = blobUrl;
          link.target = "_blank";
          link.setAttribute(
              "download",
              item.file_name
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      })
    } else if(item.fusType != 1) {
      return window.open(item.path, '_blank');
    }
  }

  showCloseMenu(id) {
    const { currentUser } = this.props;
    const { take } = this.props;
    const { userPermission } = this.props;
    if ((userPermission.notesAccess || currentUser.id == take.added_by)) {
      this.setState({
        showMenuClose: id,
      });
    }
  }

  hideCloseMenu() {
    this.setState({
      showMenuClose: false,
    });
  }

  renderFileName(file) {
    let fusType = parseInt(file.fusType) ? parseInt(file.fusType) : parseInt(file.fus_type);
    let fusStatus = parseInt(file.fusStatus) ? parseInt(file.fusStatus) : parseInt(file.fus_status);
    if (!fusType) {
        return <div className="truncateText dispIB 0" style={{minWidth: '65%', width: '67%', paddingRight: '5px', paddingLeft: '0%', fontSize: '13px',}} onClick={e => this.handleFileDownload(e, file)}>{file.file_name}</div>
    } else if (fusType) {
        if (fusStatus == 1) {
            return <div className="truncateText dispIB 1" style={{minWidth: '65%', width: '67%', paddingRight: '5px', paddingLeft: '0%', fontSize: '13px',}} onClick={e => this.handleFileDownload(e, file)}>{file.file_name}</div>
        } else if (fusStatus == 2) {
            return <div className="truncateText dispIB 2 " style={{minWidth: '65%', width: '67%', paddingRight: '5px', paddingLeft: '0%', fontSize: '13px',}}>{file.file_name} (processing)</div>
        }  else if (fusStatus == 5) {
          return <div className="truncateText dispIB 3" style={{minWidth: '65%', width: '67%', paddingRight: '5px', paddingLeft: '0%', fontSize: '13px',}}>{file.file_name} (infected file, deleted)</div>
        } else {
          return <div className="truncateText dispIB 4" style={{minWidth: '65%', width: '67%', paddingRight: '5px', paddingLeft: '0%', fontSize: '13px',}}>{file.file_name}</div>
        }
    }
  }

  render() {
    const { meeting } = this.props;
    const topicMiddleDet = this.props.topicMiddle;
    const { take } = this.props;
    const { currentUser } = this.props;
    const { userPermission } = this.props;

    let enableDiv = false;
    const { takeawaysFile } = this.props;
    const { isNoAttachmentDownload } = this.props;
    if ((userPermission.notesAccess || currentUser.id == take.added_by)) {
      enableDiv = true;
    }
    if (!isNoAttachmentDownload) {
      enableDiv = false;
    }

    takeawaysFile.map((file) => {
      file.owner = '';
      if (typeof file.firstname !== 'undefined') {
        file.owner = file.firstname;
      }
      if (typeof file.lastname !== 'undefined') {
        file.owner = file.owner + ' ' + file.lastname.charAt(0).toUpperCase();
      }
      if (file.owner) {
        file.owner = 'Added by ' + file.owner;
      }
    });

    return (
      <div className="wb-table tabLayFix" data-type="take" style={{ cursor: enableDiv ? 'pointer' : 'move', padding: '3px 0px' }}>
        {
          takeawaysFile.map((file, index) => (
            <div key={index} className="wb-table-row " onMouseEnter={() => this.showCloseMenu(file.id)} onMouseLeave={() => this.hideCloseMenu()}>
              <div className="wb-table-col wb-table-col-tag tagForAi" style={{ padding: '0px 0px 0px 10px', verticalAlign: 'middle', cursor: enableDiv ? 'pointer' : 'move' }}>
                <div className="meeting-tag-wrapper">
                  <div className="wb-table-col-edit-title-desc wrap  " data-view-acces="true">
                    <div className="meeting-tag-options" data-tag="14" data-type="attch" style={{ zIndex:1, cursor: enableDiv ? 'pointer' : 'move' }} />
                  </div>
                </div>
              </div>
              <div className="wb-table-col wb-table-col-title titleAlignLeft" data-topic-id="" style={{ padding: '4px 0px 4px 0px', fontSize: '12px', cursor: enableDiv ? 'pointer' : 'move' }}>
                <div className="topicConetentSec">
                  <div className="topic-section-div attachemntSec">
                    <div data-s={meeting.status} data-s1={userPermission.meetingAccess} data-s2={file.userId} data-s3={currentUser.id} data-s4={this.state.showMenuClose} data-s5={file.id}>
                      <div className="ai-div-section dispIB truncateText" style={{ textAlign: 'left', paddingLeft: '0px', width: '99%' }}>
                      {
                          this.renderFileName(file)
                        }
                        <div className="smallFont9 truncateText dispIB takeAwayAttachDiv">
                          {file.owner}
                        </div>
                      </div>
                      {
                        (userPermission.notesAccess || currentUser.id == file.userId) && this.state.showMenuClose == file.id
                          && (
                          <div className="floatRight dispIB hideAttachMenu closeImg" onClick={() => this.deleteTopicAttach(topicMiddleDet.id, take.id, file.id, this.state.type, file.fileSignature)} data-topic={topicMiddleDet.id} data-take={take.id}>
                            <div className="dispIB closeImg">
                              <ImgIconComp id="close_topic_take" class="memberPic" width="13" height="13" />
                            </div>
                          </div>
                          )
                        }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        }
      </div>
    );
  }
}
export default TakeAttachment;
